exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.flex[data-v-480b9e07] {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n}\n.panel-list[data-v-480b9e07] {\n  margin: 0 1.5rem;\n  max-width: 120rem;\n}\n", ""]);

